import { PayloadAction } from "@reduxjs/toolkit";
import { closeAppBackdrop, notify } from "features/app/store/slice";
import { call, put, takeEvery } from "redux-saga/effects";
import { IApiResponse } from "types/api";
import { IAccessTokenBody, ILoginForm, IUser } from "types/models/Account";
import { getStorage, removeLocalItem, setLocalItem } from "utils";
import {
  APP_REFRESH_TOKEN_NAME,
  APP_TOKEN_NAME,
  ON_FETCH_ERROR,
} from "utils/constants";
import {
  authLoginAPI,
  authUserAPI,
  forgotPasswordAPI,
  resetPasswordAPI,
  signupAPI,
} from "../models";
import {
  accessToken,
  fetchUserInfo,
  forgot,
  forgotFailure,
  forgotSuccess,
  login,
  loginFailure,
  loginSuccess,
  resetPW,
  resetPWFailure,
  resetPWSuccess,
  signup,
  signupFailure,
  signupSuccess,
  userFailure,
  userSuccess,
} from "./slice";

function* handleAccessToken(action: PayloadAction<IAccessTokenBody>) {
  try {
    const sessionData = getStorage(APP_TOKEN_NAME);
    if (sessionData !== null) {
      // const dataSessionStored =  Buffer.Buffer.from(sessionData, "base64").toString().split(".");
      // const decodeBase64 = JSON.parse(atob(dataSessionStored[1])) as IDecodeToken;
      // yield put(loginSuccess(decodeBase64.user_info as IUser));
    } else {
      yield call(removeLocalItem, APP_TOKEN_NAME);
    }
  } catch (e) {
    yield put(loginFailure(ON_FETCH_ERROR));
  }
}

function* handleLogin(action: PayloadAction<any>) {
  try {
    const response: IApiResponse<any> = yield call(
      authLoginAPI,
      action.payload
    );
    if (response.success) {
      yield put(
        loginSuccess({
          role: response.data.role,
          email: response.data.username,
          user_name: response.data.username.split("@")[0],
          department: response.data.department,
          permission: response.data.permission,
          active: response.data.is_active,
          first_name: response.data.firstname,
          last_name: response.data.lastname,
          team_name: response.data.teamname,
        } as IUser)
      );
      setLocalItem(APP_TOKEN_NAME, response.data?.access_token as string);
      setLocalItem(
        APP_REFRESH_TOKEN_NAME,
        response.data?.refresh_token as string
      );
    } else {
      if (response.detail !== "") {
        yield put(
          notify(`${response.detail}`, {
            options: { variant: "error" },
          })
        );
      }
      yield put(loginFailure(ON_FETCH_ERROR));
    }
    yield put(closeAppBackdrop());
  } catch (e) {
    yield put(closeAppBackdrop());
    yield put(loginFailure(ON_FETCH_ERROR));
  }
}

function* handleFetchUserInfo() {
  try {
    const response: IApiResponse<any> = yield call(authUserAPI);
    if (response.success) {
      yield put(
        userSuccess({
          role: response.data.role,
          email: response.data.username,
          user_name: response.data.username.split("@")[0],
          department: response.data.department,
          permission: response.data.permission,
          active: response.data.is_active,
          first_name: response.data.firstname,
          last_name: response.data.lastname,
          team_name: response.data.teamname,
        } as IUser)
      );
    } else {
      if (response.detail !== "") {
        yield put(
          notify(`${response.detail}`, {
            options: { variant: "error" },
          })
        );
      }
      yield put(userFailure(ON_FETCH_ERROR));
    }
    yield put(closeAppBackdrop());
  } catch (e) {
    yield put(closeAppBackdrop());
    yield put(userFailure(ON_FETCH_ERROR));
  }
}

function* handleSignup(action: PayloadAction<ILoginForm>) {
  try {
    const response: IApiResponse<any> = yield call(signupAPI, action.payload);

    if (response.success) {
      yield put(signupSuccess());
      yield put(
        notify(`The account creation was successful`, {
          options: { variant: "success" },
        })
      );
    } else {
      if (response.detail !== "") {
        yield put(
          notify(`${response.detail}`, {
            options: { variant: "error" },
          })
        );
      }
      yield put(signupFailure());
    }
  } catch (e) { }
}

function* handleForgotPassword(action: PayloadAction<any>) {
  try {
    const response: IApiResponse<any> = yield call(
      forgotPasswordAPI,
      action.payload
    );

    if (response.success) {
      yield put(forgotSuccess());
      yield put(
        notify(
          `We are sending you a password resetting link to your email address`,
          {
            options: { variant: "success" },
          }
        )
      );
    } else {
      if (response.detail !== "") {
        yield put(
          notify(`${response.detail}`, {
            options: { variant: "error" },
          })
        );
      }
      yield put(forgotFailure());
    }
  } catch (e) { }
}

function* handleResetPassword(action: PayloadAction<any>) {
  try {
    const response: IApiResponse<any> = yield call(
      resetPasswordAPI,
      action.payload
    );

    if (response.success) {
      yield put(resetPWSuccess());
      yield put(
        notify(`Your password was reset successfully`, {
          options: { variant: "success" },
        })
      );
    } else {
      if (response.detail !== "") {
        yield put(
          notify(`${response.detail}`, {
            options: { variant: "error" },
          })
        );
      }
      yield put(resetPWFailure());
    }
  } catch (e) { }
}

export default function* authSaga() {
  yield takeEvery(accessToken.type, handleAccessToken);
  yield takeEvery(login.type, handleLogin);
  yield takeEvery(fetchUserInfo.type, handleFetchUserInfo);
  yield takeEvery(signup.type, handleSignup);
  yield takeEvery(forgot.type, handleForgotPassword);
  yield takeEvery(resetPW.type, handleResetPassword);
}
